import React from 'react';
import { Box, useTheme } from '@mui/material';

interface GradientBackgroundProps {
  /**
   * Children to render over the gradient
   */
  children?: React.ReactNode;
  /**
   * Gradient angle in degrees
   * @default 135
   */
  angle?: number;
}

/**
 * Atom: Reusable gradient background box
 * Uses theme colors (primary → secondary) for automatic light/dark mode support
 */
export const GradientBackground: React.FC<GradientBackgroundProps> = ({
  children,
  angle = 160,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        // Dark secondary dominant, amber primary as subtle bottom accent — white text stays readable throughout
        background: `linear-gradient(${angle}deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.main} 60%, ${theme.palette.secondary.light} 100%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children}
    </Box>
  );
};
